var _desc, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIcPendingReviewM(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "30px",
    height: "30px",
    viewBox: "0 0 30 30",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "icPendingReviewM") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _desc || (_desc = /*#__PURE__*/React.createElement("desc", null, "Created with Sketch.")), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Desktop-Manage-Photos",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "icPendingReviewM"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Oval",
    fill: "#FC8106",
    cx: 15,
    cy: 15,
    r: 15
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.9155955,6.49832776 C15.8151881,6.49832776 16.5763657,6.97553759 16.5763657,7.82137529 C16.5763657,10.4023605 16.2534439,14.111326 16.2534439,16.6923113 C16.2534439,17.3647194 15.4691856,17.6465998 14.9155955,17.6465998 C14.1775684,17.6465998 13.554736,17.3646539 13.554736,16.6923113 C13.554736,14.111326 13.2318841,10.4023605 13.2318841,7.82137529 C13.2318841,6.97553759 13.9699111,6.49832776 14.9155955,6.49832776 Z",
    id: "Path",
    fill: "#FFFFFF",
    fillRule: "nonzero"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.9150614,22.1059086 C13.9533024,22.1059086 13.2318841,21.3240851 13.2318841,20.4336678 C13.2318841,19.5215185 13.9532364,18.761427 14.9150614,18.761427 C15.811267,18.761427 16.5763657,19.5215185 16.5763657,20.4336678 C16.5763657,21.3240851 15.811267,22.1059086 14.9150614,22.1059086 Z",
    id: "Path",
    fill: "#FFFFFF",
    fillRule: "nonzero"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcPendingReviewM);
export default __webpack_public_path__ + "static/media/icPendingReviewM.1b25ae2c70f89b5504d80ae146b79d57.svg";
export { ForwardRef as ReactComponent };